/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusIndividuelleAnforderungDetailDto } from '../../models/lexplus-individuelle-anforderung-detail-dto';

export interface IndividuelleAnforderungDetailControllerGetIndividuelleAnforderungDetailV1$Params {
  individuelleAnforderungID: string;
}

export function individuelleAnforderungDetailControllerGetIndividuelleAnforderungDetailV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungDetailControllerGetIndividuelleAnforderungDetailV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusIndividuelleAnforderungDetailDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungDetailControllerGetIndividuelleAnforderungDetailV1.PATH, 'get');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusIndividuelleAnforderungDetailDto>;
    })
  );
}

individuelleAnforderungDetailControllerGetIndividuelleAnforderungDetailV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}';
